export default function getRedirectsReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GETS_REDIRECTS_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GETS_REDIRECTS_ERROR':
            return {...state, ...{error: action.error}};

        case 'GETS_REDIRECTS_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}